/**
 * GroupTrip member-facing product presentation (UX-04-A).
 * Domain enums stay internal; Admin operational labels are not reused.
 */

export const GROUP_TRIP_RECRUITMENT_STATUS_LABELS = Object.freeze({
  DRAFT: '草稿',
  OPEN: '招募中',
  CLOSED: '已結束',
  CANCELLING: '取消處理中',
  CANCELLED: '已取消',
});

/** Same product wording as Journey visibility; kept local to avoid fragile coupling. */
export const GROUP_TRIP_VISIBILITY_LABELS = Object.freeze({
  PUBLIC: '所有人',
  FOLLOWERS: '追蹤者',
  PRIVATE: '僅自己',
});

export const GROUP_TRIP_APPLICATION_STATUS_LABELS = Object.freeze({
  PENDING: '待確認',
  APPROVED: '已接受',
  REJECTED: '未接受',
  WITHDRAWN: '已撤回',
});

export const GROUP_TRIP_PARTICIPANT_STATUS_LABELS = Object.freeze({
  ACTIVE: '已加入',
  WITHDRAWN: '已退出',
  REMOVED: '已移除',
});

export const GROUP_TRIP_STATUS_UNKNOWN_FALLBACK = '狀態更新';
export const GROUP_TRIP_APPLICATION_UNKNOWN_FALLBACK = '申請狀態';
export const GROUP_TRIP_PARTICIPANT_UNKNOWN_FALLBACK = '成員';
export const GROUP_TRIP_VISIBILITY_UNKNOWN_FALLBACK = '可見範圍';

export function groupTripRecruitmentStatusLabel(status) {
  const key = String(status || '').trim();
  if (!key) return GROUP_TRIP_STATUS_UNKNOWN_FALLBACK;
  return GROUP_TRIP_RECRUITMENT_STATUS_LABELS[key] || GROUP_TRIP_STATUS_UNKNOWN_FALLBACK;
}

export function groupTripVisibilityLabel(visibility) {
  const key = String(visibility || '').trim();
  if (!key) return GROUP_TRIP_VISIBILITY_UNKNOWN_FALLBACK;
  return GROUP_TRIP_VISIBILITY_LABELS[key] || GROUP_TRIP_VISIBILITY_UNKNOWN_FALLBACK;
}

export function groupTripApplicationStatusLabel(status) {
  const key = String(status || '').trim();
  if (!key) return GROUP_TRIP_APPLICATION_UNKNOWN_FALLBACK;
  return GROUP_TRIP_APPLICATION_STATUS_LABELS[key] || GROUP_TRIP_APPLICATION_UNKNOWN_FALLBACK;
}

export function groupTripParticipantStatusLabel(status) {
  const key = String(status || '').trim();
  if (!key) return GROUP_TRIP_PARTICIPANT_UNKNOWN_FALLBACK;
  return GROUP_TRIP_PARTICIPANT_STATUS_LABELS[key] || GROUP_TRIP_PARTICIPANT_UNKNOWN_FALLBACK;
}

export const GROUP_TRIP_VISIBILITY_OPTIONS = Object.freeze([
  { value: 'PUBLIC', label: GROUP_TRIP_VISIBILITY_LABELS.PUBLIC },
  { value: 'FOLLOWERS', label: GROUP_TRIP_VISIBILITY_LABELS.FOLLOWERS },
  { value: 'PRIVATE', label: GROUP_TRIP_VISIBILITY_LABELS.PRIVATE },
]);
